// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

/* eslint-disable */

/**
 * This is a automatically generated component, do not edit it.
 * If you need to edit this component, move it to some other folder.
 */

import React from 'react';
function DrugIcon19(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <g
        fill="currentColor"
        clipPath="url(#a)"
      >
        <path d="M13.216 8.414a.333.333 0 0 0 .334-.333V6.747a.333.333 0 1 0-.667 0v1.334a.333.333 0 0 0 .333.333ZM14.597 8.414a.333.333 0 0 0 .333-.333V6.747a.333.333 0 1 0-.666 0v1.334a.333.333 0 0 0 .333.333ZM15.976 8.414a.333.333 0 0 0 .333-.333V6.747a.333.333 0 1 0-.666 0v1.334a.333.333 0 0 0 .333.333ZM17.36 8.414a.333.333 0 0 0 .334-.333V6.747a.333.333 0 1 0-.667 0v1.334a.333.333 0 0 0 .334.333ZM18.74 8.414a.333.333 0 0 0 .333-.333V6.747a.333.333 0 1 0-.667 0v1.334a.333.333 0 0 0 .334.333ZM16.863 2.96h.246a.333.333 0 1 0 0-.667h-.246a.333.333 0 1 0 0 .667Z" />
        <path d="M22.55 10.573c-1.62-1.406-1.574-1.4-1.87-1.543.163-.293.122-.283.122-2.437a1.303 1.303 0 0 0-1.3-1.3h-.573l-.366-4.15A1.26 1.26 0 0 0 17.313 0h-2.667a1.243 1.243 0 0 0-1.25 1.14l-.367 4.15h-.576a1.303 1.303 0 0 0-1.3 1.3c0 2.137-.04 2.14.12 2.437-.284.14-.19.086-1.87 1.543a6.248 6.248 0 0 0-2.147 4.713v14.334A2.383 2.383 0 0 0 9.639 32h12.694a2.386 2.386 0 0 0 2.383-2.383V15.283a6.237 6.237 0 0 0-2.167-4.71ZM14.055 1.2a.583.583 0 0 1 .587-.533h2.666a.59.59 0 0 1 .59.533v.11h-1.333a1.334 1.334 0 1 0 0 2.633h1.56l.116 1.35h-4.546l.36-4.093Zm4.027 2.077h-1.5a.666.666 0 1 1 0-1.3h1.383l.116 1.3ZM11.819 6.61a.633.633 0 0 1 .633-.633h7.05a.633.633 0 0 1 .634.633v1.98a.283.283 0 0 1-.28.283h-7.757a.283.283 0 0 1-.28-.283V6.61Zm-1.976 4.467 1.513-1.317a.973.973 0 0 1 .643-.237h7.857a1.02 1.02 0 0 1 .743.24l1.514 1.314a5.574 5.574 0 0 1 1.92 4.21v1.433H7.922v-1.433a5.574 5.574 0 0 1 1.92-4.21Zm14.19 16.696h-11.56V17.387h11.56v10.386Zm-16.11-9.05h2.243v7.717H7.923v-7.717Zm0 8.384h2.576a.333.333 0 0 0 .333-.334V18.39a.334.334 0 0 0-.333-.333H7.923v-.667h3.883v10.383H7.923v-.666Zm14.41 4.226H9.665a1.72 1.72 0 0 1-1.717-1.716V28.44h16.083v1.177a1.72 1.72 0 0 1-1.7 1.716Z" />
        <path d="M18.157 25.286c2.333 0 4.173-1.19 4.173-2.706 0-1.517-1.833-2.707-4.173-2.707S14 21.063 14 22.58c0 1.516 1.817 2.706 4.157 2.706Zm0-4.746c1.9 0 3.506.936 3.506 2.04 0 1.103-1.606 2.04-3.506 2.04-1.9 0-3.49-.934-3.49-2.04 0-1.107 1.59-2.04 3.49-2.04Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path
            fill="#fff"
            d="M0 0h32v32H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export default DrugIcon19;
